module.exports = __webpack_public_path__ + "static/media/Tourplanning.2784c9e0.png";